import styled from 'styled-components/macro';
import { COLORS, Z_INDEX } from 'styleguide';

const AlertMsgWrapper = styled.div`
  z-index: ${Z_INDEX.alert};
  display: flex;
  align-items: flex-start;
  padding: 15px 16px 18px;
  width: 370px;
  font-size: 16px;
  border-radius: 4px;
  background-color: ${COLORS.line};
`;

export default AlertMsgWrapper;
